///
/// EarthBrowser
///
/// Created by Matt Giger on 1/11/2026
/// Copyright (c) 2026 Geodata Labs
///

import type { InfoWindowContentData, InfoWindowTheme } from "@/redux/userInterfaceSlice"

/**
 * Data structure for populating the info side panel
 */
export interface InfoPanelData {
	title: string
	subtitle?: string
	theme: InfoWindowTheme
	contentType: InfoWindowContentData["type"]
	contentData: InfoWindowContentData
}

/**
 * Interface for entities that can provide info panel data when focused.
 *
 * Entities that implement this interface will automatically have their
 * info panel shown when they gain focus, without needing to manually
 * dispatch Redux actions.
 */
export interface InfoPanelProvider {
	/**
	 * Get the info panel data for this entity.
	 * Called when the entity gains focus to populate the side panel.
	 *
	 * @returns The info panel data, or undefined if no panel should be shown
	 */
	getInfoPanelData(): InfoPanelData | undefined
}

/**
 * Type guard to check if an object implements InfoPanelProvider
 */
export function isInfoPanelProvider(obj: unknown): obj is InfoPanelProvider {
	return obj !== null &&
		typeof obj === "object" &&
		"getInfoPanelData" in obj &&
		typeof (obj as InfoPanelProvider).getInfoPanelData === "function"
}
